import React from "react";
import HeaderComponent from "../../Components/Header/header";
import "./catalogo.css"
import FiltersComponent from "../../Components/Filters/filters";
import ProductsSearchbarComponent from "../../Components/Products-Searchbar/products-searchbar";
import ProductsListComponent from "../../Components/Products-list/products-list";
import Footer from "../../Components/Footer/footer";

function CatalogoViewComponent() {
  return (
    <section>
      <HeaderComponent />
      <div className="catalogo-page">
        <FiltersComponent/>
        <div className="catalogo-container">
        <ProductsSearchbarComponent/>
        <ProductsListComponent/>          
        </div>
      </div>
      <Footer/>
    </section>
  );
}

export default CatalogoViewComponent;
